<template>
  <l-layout layout="xs12">
    <l-data-table
      :get-data-func="getEvents"
      :headers="historyHeaders"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      ref="list"
      :filterItems="filterItems"
    >
      <template slot="title">
        <v-layout align-center wrap>
          <span class="pr-4">违章事件历史</span>
          <v-btn flat color="primary" @click="$router.push({name: 'AppointmentOrgViolationStatistics'})">单位预约违章统计</v-btn>
          <v-radio-group row shrink v-model="locale">
            <!--            <v-radio label="已提交" :value="VIOLATION_ROLE.TRAFFIC_ADMIN"></v-radio>-->
            <!--            <v-radio label="初步确认" :value="VIOLATION_ROLE.ALARM_ADMIN"></v-radio>-->
            <!--            <v-radio label="已确认" :value="VIOLATION_ROLE.VIOLATION_ADMIN"></v-radio>-->
            <v-radio label="未冻结" value="runtime"></v-radio>
            <v-radio label="已冻结" value="history"></v-radio>
            <v-radio label="已撤销" value="cancel"></v-radio>
          </v-radio-group>
        </v-layout>
      </template>
      <template slot="filter:appointmentOrgId" slot-scope="{filter}">
        <v-autocomplete
          v-model="filter.value"
          :items="orgOptions"
          :filter="orgFilter"
          item-text="text"
          item-value="value"
          label="预约人二级单位"
          clearable
          hide-no-data
        ></v-autocomplete>
      </template>
      <!--<template slot="title-action">-->
      <!--<l-option-list-->
      <!--:options="moreActions"-->
      <!--@delete="deleteUser(selected)"-->
      <!--&gt;-->
      <!--<v-btn icon slot="activator">-->
      <!--<v-icon>$vuetify.icons.more</v-icon>-->
      <!--</v-btn>-->
      <!--</l-option-list>-->
      <!--</template>-->
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn @click="goDetails(item)" color="primary" flat>查看</v-btn>
        </td>
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
import {VIOLATION_ROLE, ViolationEvent} from '../../../object'
import {time} from '../../../ladmin/utils'

export default {
  name: 'ViolationHistory',
  data: () => ({
    VIOLATION_ROLE,
    historyHeaders: [
      {text: '车辆号牌', value: 'plate', align: 'left', placeholder: 'N/A'},
      {text: '预约人二级单位', value: 'appointmentOrgName', align: 'left', placeholder: 'N/A', sortable: false},
      {text: '预约类型', value: 'passRuleType', align: 'left', sortable: false,
        f: v => v === 'order_object' ? '个人预约' : v === 'order_group' ? '单位预约' : 'N/A'},
      {text: '电话号码', value: 'phone', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '违章区域', value: 'area', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '违章类型', value: 'typeName', align: 'right', placeholder: 'N/A', sortable: false},
      {text: '上报时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
    locale: 'runtime',
    orgOptions: []
  }),
  watch: {
    locale () {
      this.$refs.list.refresh()
    }
  },
  computed: {
    filterItems () {
      let item = {
        layout: 'xs12 md4',
        label: '违章状态',
        type: 'select',
        key: 'status',
        value: '',
        items: []
      }
      if (this.locale === 'cancel') {
        item.items = [{
          text: '已撤销',
          value: ViolationEvent.HAS_REVOKED
        }]
        // item.value = ViolationEvent.HAS_REVOKED
        item.disabled = true
      }
      else {
        item.items = [
          {text: '已提交', value: ViolationEvent.HAS_SUBMITTED},
          {text: '初步确认', value: ViolationEvent.HAS_PRELIMINARY_CONFIRMED},
          {text: '已确认', value: ViolationEvent.HAS_FINAL_CONFIRMED}
        ]
      }
      return [item, {
        layout: 'xs12 md4',
        label: '预约人二级单位',
        type: 'select',
        key: 'appointmentOrgId',
        value: '',
        precious: true,
        items: this.orgOptions
      }]
    }
  },
  methods: {
    orgFilter (item, query, name) {
      const search = (query || '').trim().toLocaleLowerCase()
      return !!search && String(name || '').toLocaleLowerCase().includes(search)
    },
    async getEvents ({pagination, sortStack, filterItems = [], search}) {
      let status
      let f = filterItems.find(t => t.key === 'status')
      if (f && f.value !== '') {
        status = f.value
      }
      else {
        status = [
          ViolationEvent.HAS_SUBMITTED,
          ViolationEvent.HAS_PRELIMINARY_CONFIRMED,
          ViolationEvent.HAS_FINAL_CONFIRMED]
      }
      if (this.locale === 'cancel') {
        status = ViolationEvent.HAS_REVOKED
      }
      const result = await this.$store.dispatch('violation/getEvents', {
        pagination,
        sortStack,
        filter: filterItems.filter(item => item.key === 'appointmentOrgId' && item.value),
        status,
        search: {key: 'plate', value: search},
        locale: this.locale === 'runtime' ? 'runtime' : 'history'
      })
      const orgNames = new Map(this.orgOptions.map(org => [org.value, org.text]))
      result.items.forEach(event => {
        event.appointmentOrgName = orgNames.get(event.appointmentOrgId) || event.appointmentOrgId || 'N/A'
      })
      return result
    },
    async loadOrganizations () {
      const options = []
      const size = 200
      for (let page = 1; ; page++) {
        const res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination: {page, rowsPerPage: size}, name: '', id: '', type: 'org'
        })
        if (res.data.status !== 1) throw new Error(res.data.msg || '查询单位失败')
        const data = res.data.data
        options.push(...data.content.map(org => ({text: org.name, value: org.id})))
        if (page * size >= data.totalElements || !data.content.length) break
      }
      this.orgOptions = options
      if (this.$refs.list) this.$refs.list.refresh()
    },
    goDetails (item) {
      let query = {id: item.id}
      if (this.locale !== 'runtime') {
        query.history = true
      }
      this.$router.push({
        name: 'ViolationEventDetails',
        params: {plate: item.plate},
        query,
      })
    }
  },
  activated () {
    if (this.$route.params.refresh) {
      this.$refs.list.refresh()
    }
  },
  created () {
    this.loadOrganizations().catch(error => this.$L.alert('error', {message: '单位列表加载失败：' + error.message}))
  }
}
</script>

<style scoped>

</style>
